// ==============================
// B2STOCK MST PATCH
// The app block only outputs 4 of the required istock properties.
// undefined != '' evaluates true, causing querySelectorAll(undefined) to throw
// and B2stock to silently fail on every product page.
// ==============================
window.istock = window.istock || {};
if (typeof window.istock.variant_selector === 'undefined') window.istock.variant_selector = '';
if (typeof window.istock.option_selector === 'undefined') window.istock.option_selector = '';
if (typeof window.istock.shop === 'undefined') window.istock.shop = 'simply-carbon-fiber.myshopify.com';
if (typeof window.istock.is_product_page === 'undefined') window.istock.is_product_page = window.location.pathname.indexOf('/products/') !== -1;
if (typeof window.istock.allow_preorder === 'undefined') window.istock.allow_preorder = false;
if (typeof window.istock.allow_resubscribe === 'undefined') window.istock.allow_resubscribe = false;
if (typeof window.istock.onchange_delay === 'undefined') window.istock.onchange_delay = 300;
if (typeof window.istock.init_delay === 'undefined') window.istock.init_delay = 300;
if (typeof window.istock.logs === 'undefined') window.istock.logs = false;

// ==============================
// B2STOCK FALLBACK VISIBILITY
// B2stock's own init calls istock_init.php async — if that returns empty it bails
// before ever showing the wrapper. We bypass it entirely:
//   1. On page load: 700ms after window.load (plenty of time for B2stock's API call),
//      if the ATC button is disabled (= current variant unavailable) and the wrapper is
//      still hidden, force it visible.
//   2. On variant:change: directly toggle based on variant.available from the event.
// ==============================
function b2stockShow(wrapper) {
  // Restore title text — B2stock clears innerHTML when it hides the widget
  var titleEl = wrapper.querySelector('.iStock-title');
  if (titleEl && !titleEl.textContent.trim()) {
    titleEl.textContent = (window.istock && window.istock.title) || 'Out Of Stock!';
  }
  wrapper.style.display = 'block';
}

function b2stockSync() {
  var wrapper = document.querySelector('.iStock-wrapper');
  if (!wrapper) return;
  var atcBtn = document.querySelector('[data-add-to-cart]');
  if (atcBtn && atcBtn.disabled) {
    b2stockShow(wrapper);
  }
}
window.addEventListener('load', function() {
  setTimeout(b2stockSync, 700);
});

document.addEventListener('variant:change', function(e) {
  var wrapper = document.querySelector('.iStock-wrapper');
  if (!wrapper) return;
  var variant = e.detail && e.detail.variant;
  if (!variant) return;
  if (variant.available === false) {
    b2stockShow(wrapper);
  } else {
    wrapper.style.display = 'none';
  }
});

// ==============================
// CART STATE & CORE LOGIC
// ==============================
let globalCart = null;
let isSyncingCart = false;
let fetchPatched = false;
let isInternalCartUpdate = false;

document.addEventListener('cart:updated', async (event) => {
  if (isInternalCartUpdate || !window.si_product) return;

  const cart = event.detail.cart || {};
  const items = cart.items || [];
  const siId = String(window.si_product);
  const siItem = items.find(it => String(it.id) === siId);

  if (siItem && items.length === 1) {
    isInternalCartUpdate = true;
    try {
      await removeFromCart(siId);
    } finally {
      isInternalCartUpdate = false;
    }
    return;
  }

  if (siItem && siItem.quantity > 1) {
    isInternalCartUpdate = true;
    try {
      await setLineItemQuantity(siId, 1);
    } finally {
      isInternalCartUpdate = false;
    }
    return;
  }
});

async function addToCart(variantId) {
  if (!variantId) throw new Error('addToCart: missing variantId');
  const siId = String(variantId);
  await refreshCart();

  const existing = (globalCart?.items || []).find(it => String(it.id) === siId);
  if (existing) {
    if (existing.quantity > 1) {
      await setLineItemQuantity(siId, 1);
    } else {
      document.dispatchEvent(new CustomEvent('ajaxProduct:updated', {
        detail: { product: { id: variantId, alreadyPresent: true } }
      }));
    }
    return existing;
  }

  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: Number(variantId), quantity: 1 })
  });
  if (!res.ok) throw new Error('Could not add to cart.');
  const data = await res.json();
  await refreshCart();
  return data;
}

async function addMultipleToCart(variants) {
  if (!Array.isArray(variants) || variants.length === 0)
    throw new Error('addMultipleToCart: variants must be a non-empty array');

  const formData = {
    items: variants.map(v => ({ id: v.id, quantity: v.quantity || 1, properties: v.properties }))
  };

  const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(formData)
  });
  if (!res.ok) throw new Error('Failed to add items to cart');
  window.location.href = '/checkout';
}

async function removeFromCart(variantId) {
  if (!variantId) throw new Error('removeFromCart: missing variantId');
  const updates = { [String(variantId)]: 0 };
  const res = await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ updates })
  });
  if (!res.ok) throw new Error('Could not remove from cart.');
  const cart = await res.json();
  document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart } }));
  await refreshCart();
  return cart;
}

async function setLineItemQuantity(variantIdStr, qty) {
  const updates = { [variantIdStr]: qty };
  const res = await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ updates })
  });
  if (!res.ok) throw new Error('Failed to set quantity');
  const cart = await res.json();
  document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart } }));
  await refreshCart();
  return cart;
}

// ==============================
// CART MONITORING HELPERS
// ==============================
function initGlobalCart() {
  monitorShopifyCartUpdates();
  refreshCart();
}

function monitorShopifyCartUpdates() {
  if (fetchPatched) return;
  fetchPatched = true;

  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const [url] = args;
    const isMutation = isCartMutationRequest(url);
    return originalFetch.apply(this, args).then(async (response) => {
      if (isMutation && response.ok) await refreshCart();
      return response;
    });
  };
}

function isCartMutationRequest(url) {
  return typeof url === 'string' && /\/cart\/(add|change|update|clear|remove)(\.js)?(\?|$)/.test(url);
}

let cartSyncPromise = null;
async function refreshCart() {
  // Return the in-flight request so concurrent callers await the SAME sync
  // instead of resolving early with a stale globalCart
  if (cartSyncPromise) return cartSyncPromise;
  cartSyncPromise = (async () => {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error('failed to fetch cart');
      const cart = await res.json();
      globalCart = cart;
      if (!isInternalCartUpdate) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: globalCart } }));
      }
    } catch (err) {
      console.error('failed to fetch cart:', err);
    } finally {
      cartSyncPromise = null;
    }
  })();
  return cartSyncPromise;
}

async function cleanCart() {
  try {
    if (!globalCart) await refreshCart();
    if (globalCart?.items?.length) {

      const updates = {};
      globalCart.items.forEach(item => {
        const isFastProcessing = String(item.id) === String(window.si_product);
        // Only lines the gift system itself added carry _free_gift — never remove
        // other $0 lines (100%-off discount codes, GWP apps, $0 SKUs)
        const isFreeGift = item.properties && item.properties._free_gift === 'true';
        if (isFastProcessing || isFreeGift) updates[item.key] = 0;
      });
      if (Object.keys(updates).length > 0) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates })
        });
        await refreshCart();
        document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart: globalCart } }));
      }
    }
  } catch (err) {
    console.error('Failed to clean cart on load:', err);
  }
}

// ==============================
// EVENT HANDLERS
// ==============================
document.addEventListener("drawerOpen", async () => {
  try { await cleanCart(); } catch (e) { console.error(e); }
});
document.addEventListener("cart:updated", cleanCart, { once: true });

window.addEventListener('pageshow', (e) => {
  // bfcache restores (Back from checkout) skip DOMContentLoaded entirely — re-sync and re-clean
  if (e.persisted) refreshCart().then(() => cleanCart());
});

document.addEventListener("DOMContentLoaded", () => {
  monitorShopifyCartUpdates();
  // Await the first cart sync BEFORE cleaning — calling cleanCart with an
  // unpopulated globalCart made the page-load cleanup a silent no-op
  refreshCart().then(() => cleanCart());

  const form = document.querySelector('form#CartDrawerForm');
  async function addFreeGifts() {
    const giftInputs = document.querySelectorAll('.free-gift-box.is-done > input');
    if (!giftInputs.length) return;
    const variants = Array.from(giftInputs)
      .map(input => ({
        id: parseInt(input.value, 10),
        quantity: 1,
        properties: { _free_gift: 'true' }
      }))
      .filter(v => Number.isFinite(v.id));
    if (!variants.length) return;
    await addMultipleToCart(variants);
  }

  if (form) {
    const fastProcessing = form.querySelector('.drawer__footer .fastprocessing');
    if (fastProcessing || form.querySelector('.free-gift-box.is-done')) {
      form.addEventListener("submit", async (event) => {
        event.preventDefault();
        try {
          // Re-sync and drop stale gifts BEFORE deciding what ships — is-done boxes
          // re-render from the fresh cart, so still-qualified gifts re-add below
          await refreshCart();
          await cleanCart();
          if (fastProcessing && window.si_product) await addToCart(window.si_product);
          await addFreeGifts();
        } catch (err) {
          console.error('Error during form submission:', err);
        }
        // A failed freebie must never block a paying customer
        window.location.href = '/checkout';
      });
    }
  }

  const fastProcessingSpan = document.querySelector('form#CartDrawerForm span.fastprocessing');
  if (fastProcessingSpan) {
    fastProcessingSpan.addEventListener("click", async () => {
      try {
        await refreshCart();
        await cleanCart();
        // This is the "without the add-on" path — also REMOVE the add-on if a
        // previous checkout attempt already put it in the cart
        if (window.si_product) {
          const present = (globalCart?.items || []).some(it => String(it.id) === String(window.si_product));
          if (present) await removeFromCart(window.si_product);
        }
        await addFreeGifts();
      } catch (err) {
        console.error('Error adding gifts on fast processing click:', err);
      }
      window.location.href = '/checkout';
    });
  }

  document.addEventListener('click', async (e) => {
    // Check if the clicked element matches the selector
    const button = e.target.closest('.btn.rec-add:not(.rec-vs-open)');
    if (!button) return; // ignore clicks elsewhere

    const variantId = button.dataset.id;
    if (!variantId) return;

    // Add loading state
    button.classList.add('btn--loading');

    try {
      // Await your async function
      await addToCart(variantId);
      document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart: globalCart } }));
    } catch (error) {
      console.error('Failed to add to cart:', error);
    } finally {
      // Always remove loading class, even on error
      button.classList.remove('btn--loading');
    }
  });



  // ==============================
  // CART-AWARE VARIANT MATCHING
  // Items already in the cart (e.g. a case with Device: iPhone 17 Pro Max)
  // pin the matching variant of an upsell, so "+ ADD" can skip the dropdown.
  // Matching is by option VALUE (normalized), so "Device" on the case still
  // pins "Phone Model" on a protector as long as the values are spelled alike.
  // ==============================
  function cartOptionValueSet() {
    const values = new Set();
    const items = (globalCart && globalCart.items) || [];
    items.forEach((item) => {
      (item.options_with_values || []).forEach((opt) => {
        if (opt && opt.value) values.add(String(opt.value).trim().toLowerCase());
      });
    });
    return values;
  }

  function resolvePinnedUpsellOptions(product) {
    const cartValues = cartOptionValueSet();
    const optionCount = (product.options || []).length;
    const pinned = [];
    for (let i = 0; i < optionCount; i++) {
      if (!cartValues.size) { pinned.push(null); continue; }
      const optionValues = [...new Set(product.variants.map(v => v.options[i]))];
      const matches = optionValues.filter(v => cartValues.has(String(v).trim().toLowerCase()));
      pinned.push(matches.length === 1 ? matches[0] : null);
    }
    return pinned;
  }

  function resolveMatchedUpsellVariant(selector) {
    const productJson = selector && selector.dataset.product;
    if (!productJson) return null;

    let product;
    try { product = JSON.parse(productJson); } catch (_) { return null; }
    if (!product.variants || !product.variants.length) return null;

    const pinned = resolvePinnedUpsellOptions(product);

    // Only add silently when the cart pins EVERY option to exactly one value
    if (!pinned.length || pinned.some(v => v === null)) return null;

    return product.variants.find(v =>
      v.available && v.options.every((opt, i) => opt === pinned[i])
    ) || null;
  }

  document.addEventListener('click', async (e) => {
    const button = e.target.closest('.btn.rec-add.rec-vs-open');
    if (!button) return;

    const variantId = button.dataset.id;
    if (!variantId) return;

    button.classList.add('btn--loading');

    const selector = document.querySelector(`.upsell-variant-selector[data-vsp="${variantId}"]`);

    // Cart already pins every option (e.g. Device) → add the matched variant, no dropdown
    const matched = resolveMatchedUpsellVariant(selector);
    if (matched) {
      try {
        await addToCart(matched.id);
        document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart: globalCart } }));
      } catch (error) {
        console.error('Failed to add matched variant:', error);
      } finally {
        button.classList.remove('btn--loading');
      }
      return;
    }

    setTimeout(() => {
      button.classList.remove('btn--loading');

      if (selector) {
        selector.classList.add('is-active');
        const cartDrawer = document.querySelector('#CartDrawer');
        if (cartDrawer) cartDrawer.classList.add('vs-open');
      }
    }, 200);
  });

  function closeVselector() {
    // Remove vs-open from the CartDrawer
    const cartDrawer = document.querySelector('#CartDrawer');
    if (cartDrawer) cartDrawer.classList.remove('vs-open');

    // Remove active state from all variant selectors
    document.querySelectorAll('.upsell-variant-selector.is-active')
      .forEach(el => el.classList.remove('is-active'));

    // Remove loading state from any upsell buttons
    document.querySelectorAll('.btn.rec-add.btn--loading')
      .forEach(btn => btn.classList.remove('btn--loading'));
  }

  // Attach listeners to all .vs-close buttons
  document.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('.vs-close');
    if (closeBtn) closeVselector();
  });




  // ==============================
// DYNAMIC VARIANT OPTION DISABLING
// ==============================
function updateVariantOptionAvailability(selector) {
  const productJson = selector.dataset.product;
  if (!productJson) return;

  let product;
  try { product = JSON.parse(productJson); } catch (e) { return; }

  const pillGroups = selector.querySelectorAll('.product-option-pills');
  const availableVariants = product.variants.filter(v => v.available);

  // Build current selection
  const currentSelection = [];
  pillGroups.forEach(group => {
    const groupName = `upsell-option-${product.id}-${group.dataset.optionIndex}`;
    const checked = group.querySelector(`input[name="${groupName}"]:checked`);
    currentSelection.push(checked ? checked.value : null);
  });

  // For each option group
  pillGroups.forEach((group, groupIndex) => {
    const inputs = group.querySelectorAll('input[type="radio"]');
    const optionIndex = group.dataset.optionIndex;

    inputs.forEach(input => {
      const value = input.value;
      let isAvailable = false;

      // Test: is there ANY available variant that matches:
      // - All current selections (except this one)
      // - This value for the current option
      for (const variant of availableVariants) {
        let matches = true;

        for (let i = 0; i < product.options.length; i++) {
          if (i === groupIndex) {
            // This is the option we're testing
            if (variant.options[i] !== value) {
              matches = false;
              break;
            }
          } else {
            // Other options: must match current selection (or be null)
            const selected = currentSelection[i];
            if (selected && variant.options[i] !== selected) {
              matches = false;
              break;
            }
          }
        }

        if (matches) {
          isAvailable = true;
          break;
        }
      }

      // Update UI
      input.disabled = !isAvailable;
      const label = input.nextElementSibling;
      if (label) {
        label.classList.toggle('sold-out', !isAvailable);
      }
    });
  });

  // Auto-select first available if nothing selected
  const hasAnySelection = currentSelection.some(v => v !== null);
  if (!hasAnySelection && availableVariants.length > 0) {
    const first = availableVariants[0];
    pillGroups.forEach((group, idx) => {
      const radio = group.querySelector(`input[value="${first.options[idx].replace(/"/g, '\\"')}"]`);
      if (radio && !radio.disabled) {
        radio.checked = true;
      }
    });
  }
}

// Listen to all radio changes in variant selectors
document.addEventListener('change', (e) => {
  const radio = e.target;
  if (!radio.matches('.upsell-variant-selector input[type="radio"]')) return;

  const selector = radio.closest('.upsell-variant-selector');
  if (!selector) return;

  // Small delay to ensure DOM is updated
  setTimeout(() => updateVariantOptionAvailability(selector), 10);
});


  /* --------------------------------------------------------------
   UPSELL PILL SELECTOR → CART (NO PRICE UPDATE)
   -------------------------------------------------------------- */

document.addEventListener('click', async (e) => {
  const confirmBtn = e.target.closest('.upsell-confirm-btn');
  if (!confirmBtn) return;

  const selector = confirmBtn.closest('.upsell-variant-selector');
  if (!selector) return;

  const productJson = selector.dataset.product;
  if (!productJson) return;

  let product;
  try { product = JSON.parse(productJson); } catch (err) {
    return console.error('JSON parse error:', err);
  }

  // COLLECT SELECTED OPTIONS
  const selectedOptions = [];
  const pillGroups = selector.querySelectorAll('.product-option-pills');

  let hasSelection = true;
  pillGroups.forEach(group => {
    const select = group.querySelector('select');
    const value = select ? select.value : null;

    if (!value) hasSelection = false;
    selectedOptions.push(value);
  });

  if (!hasSelection) {
    alert('Please select all options.');
    return;
  }

  // FIND MATCHING VARIANT
  const variant = product.variants.find(v =>
    v.options.every((opt, i) => opt === selectedOptions[i])
  );

  if (!variant) {
    alert('Selected combination not available.');
    return;
  }

  if (!variant.available) {
    alert('This variant is sold out.');
    return;
  }

  // ADD TO CART
  confirmBtn.classList.add('btn--loading');
  confirmBtn.disabled = true;

  try {
    await addToCart(variant.id);
    closeVselector();
    document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart: globalCart } }));
  } catch (err) {
    console.error('Add failed:', err);
    alert('Could not add item.');
  } finally {
    confirmBtn.classList.remove('btn--loading');
    confirmBtn.disabled = false;
  }
});

// AUTO-SELECT FIRST AVAILABLE ON OPEN
document.addEventListener('click', (e) => {
  const openBtn = e.target.closest('.btn.rec-add.rec-vs-open');
  if (!openBtn) return;

  setTimeout(() => {
    const selector = document.querySelector('.upsell-variant-selector.is-active');
    if (!selector) return;

    const productJson = selector.dataset.product;
    if (!productJson) return;

    let product;
    try { product = JSON.parse(productJson); } catch (_) { return; }

    const availableVariants = product.variants.filter(v => v.available);
    if (!availableVariants.length) {
      const btn = selector.querySelector('.upsell-confirm-btn');
      btn.disabled = true;
      btn.textContent = 'Sold Out';
      return;
    }

    // Preselect from the cart match where possible (e.g. Device pinned by the
    // case already in the cart), falling back to the first available variant
    const pinned = resolvePinnedUpsellOptions(product);
    const first = availableVariants[0];
    const pillGroups = selector.querySelectorAll('.product-option-pills');

    pillGroups.forEach((group, idx) => {
      const select = group.querySelector('select');
      if (!select) return;
      const value = pinned[idx] != null ? pinned[idx] : first.options[idx];
      if (value != null) select.value = value;
    });

    // Trigger dynamic update
    updateVariantOptionAvailability(selector);

    const btn = selector.querySelector('.upsell-confirm-btn');
    btn.disabled = false;
    btn.textContent = 'Confirm';
  }, 250);
});
  




  function initCountdown(el) {
    const id = el.id || `countdown-${Math.random().toString(36).slice(2)}`;
    const minutes = parseInt(el.dataset.minutes, 10) || 10;
    const textTemplate = el.dataset.text || "⏳ Time left: {time}";
    const cycleSeconds = minutes * 60;

    function pad(n) { return n.toString().padStart(2, '0'); }

    // Start fresh each time (no persistence)
    let startTime = Date.now();

    function update() {
      const now = Date.now();
      const elapsed = Math.floor((now - startTime) / 1000);
      const remainder = elapsed % cycleSeconds;
      let secondsLeft = cycleSeconds - remainder;

      // Reset automatically when it reaches zero
      if (secondsLeft <= 0 || secondsLeft > cycleSeconds) {
        startTime = Date.now();
        secondsLeft = cycleSeconds;
      }

      const m = Math.floor(secondsLeft / 60);
      const s = secondsLeft % 60;
      const formattedTime = `${pad(m)}:${pad(s)}`;

      el.textContent = textTemplate.replace("{time}", formattedTime);
    }

    update();
    setInterval(update, 1000);
  }


  if(document.querySelectorAll(".countdown")) document.querySelectorAll(".countdown").forEach(initCountdown);



});



document.addEventListener('DOMContentLoaded', function () {

  const stickyEl = document.querySelector('.sticky-atc');
  const targetEl = document.querySelector('.payment-buttons .add-to-cart');

  if (stickyEl && targetEl) {
    let lastY = window.scrollY;

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const currentY = window.scrollY;
        const scrollingDown = currentY > lastY;
        lastY = currentY;

        if (!entry.isIntersecting && scrollingDown) {
          // Button went above (scrolled down past it)
          stickyEl.classList.add('sticky-shown');
        } else if (entry.isIntersecting) {
          // Button visible again — remove sticky
          stickyEl.classList.remove('sticky-shown');
        }
      });
    }, { threshold: 0 });

    observer.observe(targetEl);
  }


});



document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.megamenu-left-item').forEach(function (item) {
    item.addEventListener('click', function () {
      const title = this.dataset.title;
      document.querySelectorAll('.megamenu-left-item').forEach(el => el.classList.remove('active'));
      this.classList.add('active');
      document.querySelectorAll('.megamenu-right-item').forEach(el => el.classList.remove('mar-active'));
      const target = document.querySelector(`.megamenu-right-item[data-title="${CSS.escape(title)}"]`);
      if (target) target.classList.add('mar-active');
      document.querySelectorAll('.mar-blk-flx').forEach(el => el.classList.add('mar-hide'));
    });
  });

  if (window.matchMedia('(min-width: 769px)').matches) {
    document.querySelectorAll('.site-nav-item.hover-show').forEach(function (item) {
      item.addEventListener('mouseover', function () {
        document.querySelectorAll('.megamenu-right-item').forEach(el => el.classList.remove('mar-active'));
        document.querySelectorAll('.mar-blk-flx').forEach(el => el.classList.remove('mar-hide'));
      });
      item.addEventListener('mouseout', function () {
        document.querySelectorAll('.megamenu-left-item').forEach(el => el.classList.remove('active'));
        document.querySelectorAll('.mar-blk-flx').forEach(el => el.classList.remove('mar-hide'));
      });
    });

    document.querySelectorAll('.mar-blk-flx').forEach(function (item) {
      item.addEventListener('click', function () {
        this.classList.add('mar-hide');
      });
    });
  }
});

